import getMainReviewProducts, {
  ResGetMainReviewProducts,
} from '@/service/market/review/getMainReviewProducts';
import { useQuery } from '@tanstack/react-query';
import { RQReveiwKey } from './RQReviewKey';

const useMainReviewProductsQuery = () => {
  return useQuery<
    ResGetMainReviewProducts,
    object,
    ResGetMainReviewProducts['result'][],
    (typeof RQReveiwKey)['mainReviewProducts']
  >({
    queryKey: RQReveiwKey['mainReviewProducts'],
    queryFn: getMainReviewProducts,
    select: (data) => {
      const sliceNum = 3;
      const result = [];
      let parsedSlideData = [];
      for (let i = 0; i < data.result.length; i++) {
        if (i !== 0 && i % sliceNum === 0) {
          result.push(parsedSlideData);
          parsedSlideData = [];
        }
        parsedSlideData.push(data.result[i]);
        if (i === data.result.length - 1) {
          result.push(parsedSlideData);
        }
      }
      return result;
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });
};

export default useMainReviewProductsQuery;
